// extracted by mini-css-extract-plugin
export var box = "serviceItem-module--box--jABvb";
export var badge = "serviceItem-module--badge--qHbNp";
export var title = "serviceItem-module--title--QXKdN";
export var firstDescription = "serviceItem-module--firstDescription--A15rK";
export var secondDescription = "serviceItem-module--secondDescription--lPoi+";